import Link from 'components/links/Link';
import React, { useEffect, useState } from 'react';

import PoiTypeIcon from '../icons/PoiTypeIcon';
import { getPoiAreas } from 'utils/POIHelpers';

function PoiHeadlineBar({ poi }) {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    const onScroll = () => {
        const { scrollY } = window;
        if (scrollY > 150) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    const { region, municipality } = getPoiAreas(poi);

    return (
        <section
            id="headline"
            className={`mt-4 mb-4 py-2 transition sticky top-0 bg-white z-20  ${scrolled ? 'shadow-lg' : ''}`}
        >
            <div className="container flex items-center space-x-4">
                <span className="text-5xl md:text-6xl">
                    {' '}
                    {poi.type && <PoiTypeIcon slug={poi.type.slug} size="1em" />}
                </span>
                <div>
                    <h1 className="leading-tight">{poi.name}</h1>
                    {municipality && region && (
                        <h5>
                            <Link to={`/destinacija/${municipality.slug}`} styles="hover:underline">
                                {municipality.name}
                            </Link>
                            ,{' '}
                            <Link to={`/destinacija/${region.slug}`} styles="hover:underline">
                                {region.name}
                            </Link>
                        </h5>
                    )}
                </div>
            </div>
        </section>
    );
}

PoiHeadlineBar.propTypes = {};

export default PoiHeadlineBar;
